module.exports.screens = {
  xs: '375px',
  sm: '480px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1680px',
};
